import { jsx as _jsx } from "react/jsx-runtime";
import { ContentItemInternal } from '#pplx/frontend/aether/components/ContentItem/index.js';
import { useMenuContext } from '#pplx/frontend/aether/components/internal/menu/useMenuContext.js';
import classNames from 'classnames';
/**
 * A non-interactive menu row for displaying informational content.
 * Renders ContentItemInternal directly (bypassing MenuItemBase) so it is
 * excluded from keyboard navigation and the menu item registry.
 */
export function MenuInfoItem({ children, leadingAccessory, trailingAccessory, subtitle, }) {
    const menuContext = useMenuContext();
    const isMobileBottomSheet = Boolean(menuContext?.isMobileBottomSheet);
    const hasWidthConstraint = menuContext?.hasWidthConstraint;
    return (_jsx(ContentItemInternal, { leadingAccessory: leadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, rounded: true, size: isMobileBottomSheet ? 'large' : 'default', className: classNames(hasWidthConstraint
            ? 'max-w-full'
            : 'min-w-[calc(var(--radix-dropdown-menu-trigger-width)-theme(spacing.2))]'), children: children }));
}
//# sourceMappingURL=MenuInfoItem.js.map